import React from "react";
import { PublicSiteFrame } from "./PublicSiteFrame";
import { PublicEventListAndDetail } from "./PublicEventListAndDetail";

export const PublicEventFromRoute = () => {
  return (
    <PublicSiteFrame>
      <PublicEventListAndDetail />
    </PublicSiteFrame>
  );
};
